module.exports = __webpack_public_path__ + "img/logo-jjif1.63dc8df7.jpg";